import _ from "lodash";
/** External */
import React from "react";
import { Checkbox } from "@toddle-edu/ds-web";

/** Internal */
import { useI18n } from "Hooks";
import { colors } from "Constants";
import { getStyleStrippedText } from "Utils";

/** Relative */
import classes from "./SubjectDependenciesInfo.scss";

const styles = {
  checkboxStyles: {
    background: colors.surfaceOnError,
  },
};

const SubjectDependenciesInfo = props => {
  const {
    title,
    isCheckboxChecked,
    onClickCheckbox,
    subjectDependencies,
  } = props;

  const { t } = useI18n(["classRoom"]);

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>

      {_.map(subjectDependencies, subjectDependency => {
        const { id, label } = subjectDependency || {};
        return (
          <ul className={classes.listItem} key={id}>
            <li
              dangerouslySetInnerHTML={{
                __html: getStyleStrippedText({
                  text: label,
                  type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                }),
              }}
            />
          </ul>
        );
      })}

      <div className={classes.confirmationText}>
        {t("classRoom:please_confirm_the_changes")}
      </div>
      <div
        className={classes.alertWithCheckboxContainer}
        onClick={onClickCheckbox}
      >
        <Checkbox isChecked={isCheckboxChecked} color={styles.checkboxStyles} />
        <span>{t("classRoom:would_like_to_proceed")}</span>
      </div>
    </div>
  );
};

export default SubjectDependenciesInfo;
